import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Type representing the possible states of the service worker update check
 */
export type UpdateCheckStatus = 'checking' | 'up-to-date' | 'update-available' | null;

/**
 * Service to share service worker update check status between components.
 * Used by app.component to report status and login-screen to display it.
 */
@Injectable({
	providedIn: 'root',
})
export class UpdateStatusService {
	// BehaviorSubject to hold the current update check status
	private statusSubject = new BehaviorSubject<UpdateCheckStatus>(null);

	// Public observable for components to subscribe to
	public status$: Observable<UpdateCheckStatus> = this.statusSubject.asObservable();

	constructor() {}

	/**
	 * Set the current update check status
	 * @param status The new status to set
	 */
	setStatus(status: UpdateCheckStatus): void {
		this.statusSubject.next(status);
	}

	/**
	 * Get the current status value synchronously
	 * @returns The current update check status
	 */
	getCurrentStatus(): UpdateCheckStatus {
		return this.statusSubject.getValue();
	}
}
